import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withNamespaces } from 'react-i18next';
import TimesheetBankWeekSummary from './TimesheetBankWeekSummary';
import PayBankBalance from '../bankBalance/payBank/PayBankBalance';
import VacationBankBalance from '../bankBalance/vacationBank/VacationBankBalance';
import styles from '../../styles/timesheet.module.css';

const useStyles = theme => ({
    root: {
        width: '100%',
        marginTop: '20px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    firstCell: {
        width: '400px',
        '@media (max-width: 600px)': {
            width: "170px"
        },
        paddingTop: '5px',
        paddingLeft: '15px',
        textAlign: 'left'
    },
    secondCell: {
        width: '400px',
        '@media (max-width: 600px)': {
            width: "80px"
        },
        paddingTop: '5px'
    },
    thirdCell: {
        width: '400px',
        '@media (max-width: 600px)': {
            width: "35px"
        },
    },
    fourthCell: {
        width: '400px',
        '@media (max-width: 600px)': {
            width: "50px"
        },
        paddingTop: '15px'
    },
    appBar: {
        top: 'auto',
        bottom: 0,
        height: '35px!important',
    },
    toolBar: {
        minHeight: '35px',
    },
    preApproved: {
        right: 0,
        position: 'absolute',
        marginRight: '5px'
    },
    total: {
        width: '100%'
    },
    appBarForm: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
    },
    titleAppBarForm: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    accordionSummary: {
        color: 'var(--color2) !important'
    }
});

class TimesheetBankBalance extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            dataWeek: this.props.data
        }
    }

    componentDidMount() {
        this.setState({ expanded: 'panel0' });
        this.resizeForm();
    }

    handleAccordion = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('[data-id=headerTimesheetBalance]').clientHeight;
            const offSet = 70;

            // - 70 => subtract the total div
            const customHeight = height - titleBar - offSet;

            document.querySelector('#divBank').style.height = `${customHeight}px`;
            document.querySelector('#divBank').style.overflowX = 'hidden';
        }, 1000);
    }

    render() {
        const { t } = this.props;
        const { classes } = this.props;

        return (
            <div id="divBank" className={styles.rootTimesheetBank + ' ' + classes.root}>
                <Accordion className={classes.accordionSummary} expanded={this.state.expanded === 'panel0'} onChange={this.handleAccordion('panel0')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className={classes.iconAccordion} />}
                        aria-controls="panel2a-content"
                        id="panel0a-header"
                    >
                        <div>{t("timesheet:bank-balance.weekSummary")}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TimesheetBankWeekSummary data={this.state.dataWeek} />
                    </AccordionDetails>
                </Accordion>
                <Accordion className={classes.accordionSummary} expanded={this.state.expanded === 'panel1'} onChange={this.handleAccordion('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className={classes.iconAccordion} />}
                        aria-controls="panel2a-content"
                        id="panel1a-header"
                    >
                        <div>{t("timesheet:bank-balance.payBank")}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <PayBankBalance isFromBankBalanceMenu={false} />
                    </AccordionDetails>
                </Accordion>
                <Accordion className={classes.accordionSummary} expanded={this.state.expanded === 'panel2'} onChange={this.handleAccordion('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon className={classes.iconAccordion} />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <div>{t("timesheet:bank-balance.vacationBank")}</div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <VacationBankBalance isFromBankBalanceMenu={false} />
                    </AccordionDetails>
                </Accordion>
            </div>
        )
    }
}

export default withNamespaces(['timesheet', 'bankBalance'], { wait: true })((withStyles(useStyles)(TimesheetBankBalance)));